import styled from 'styled-components';

export const GalleryModalContainer = styled.div`
  width: 100%;
  max-width: 70rem;
  margin: 0 auto;
`;
